import { Component, OnInit } from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {DialogErrorComponent} from '../../dialogs/dialog-error/dialog-error.component';
import {FormBuilder, FormGroup} from '@angular/forms';
import {AudioStream} from '../../models/audio-stream.model';
import {Html5playersStatsService} from '../../services/html5players-stats-service';

@Component({
  selector: 'app-streamup-html5players',
  templateUrl: './html5players.component.html',
  styleUrls: ['./html5players.component.scss']
})
export class Html5playersComponent implements OnInit {

    loadingStreams$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    hasStreams$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    streams$: BehaviorSubject<AudioStream[]> = new BehaviorSubject<AudioStream[]>([]);
    streamsSettingsForm: FormGroup;

    statuses = [
        {value: '1', viewValue: 'New Entries'},
        {value: '2', viewValue: 'Need Review'},
        {value: '4', viewValue: 'Completed'},
        {value: '3', viewValue: 'Trash'}
    ];

  constructor(
      private html5playersStatsService: Html5playersStatsService,
      private formBuilder: FormBuilder,
      public snackBar: MatSnackBar,
      private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
      this.createForm();
      this.getStreams();
  }

    createForm() {
        this.streamsSettingsForm = this.formBuilder.group({
            streamStatus: ['1'],
        });
    }

  getStreams(){
    this.loadingStreams$.next(true);
    this.html5playersStatsService.getStreams(this.streamsSettingsForm.value.streamStatus)
        .subscribe((streams: AudioStream[]) => {
          this.streams$.next(streams);
          this.hasStreams$.next(streams.length > 0);
          this.loadingStreams$.next(false);
        });
  }

  updateStreamStatus(audioStream: number, newStatus: number){
      this.html5playersStatsService.updateStreamStatus(audioStream, newStatus)
          .subscribe((response: any) => {
              if (!response.error){
                  this.snackBar.open('Stream status updated!!', null, {duration: 1000});
                  this.getStreams();
              }else{
                  this.snackBar.open(response.message.information, null, {duration: 3000});
              }
          }, (errorResponse: any) => {
              this.handleError(errorResponse.error.message.information);
          });
  }
    handleError(errorInformation: string){
        return this.dialog
            .open(DialogErrorComponent, {
                data: {
                    error: errorInformation,
                },
                width: '600px',
                role: 'dialog'
            })
            .afterClosed()
            .subscribe();
    }

}
